/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { CmsBlockRequest, CmsBlockResponse } from "state/cms-block";

import { CMS_BLOCK_REQUEST, CMS_BLOCK_RESPONSE } from "state/cms-block";
import { cmsBlock } from "queries";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: CmsBlockRequest) => {
      const { block } = await client(cmsBlock, {
        identifier: msg.identifier,
      }, { cache: true });

      return ({
        tag: CMS_BLOCK_RESPONSE,
        data: block,
      }: CmsBlockResponse);
    },
    subscribe: { [CMS_BLOCK_REQUEST]: true },
  });
};

export default registerClient;
